"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __importDefault(require("../modal/index"));
exports.default = {
    /*
    * 请求第三方登录
    * */
    request: function () {
        var logindata = {
            "autoResize": false,
            "agentPageUrl": self.location.origin + '/loginagent.html',
            "callBack": "loginok",
            "redirectUrl": self.location.href,
            "data": {
                "domainName": "roadshow.eastmoney.com",
                "deviceType": "web",
                "productType": "emlive",
                "version": "16.0.0"
            }
        };
        // 通行证接口地址
        var loginurl = '//exaccount2.eastmoney.com/Home/Login?request=' + encodeURIComponent(JSON.stringify(logindata));
        var loginhtml = '<iframe id="loginframe" frameborder="0" width="360" height="460" src=' + loginurl + '></iframe>';
        var loginmodal = new index_1.default({
            content: loginhtml,
            showtitle: false
        });
        loginmodal.show();
        window.loginok = function () {
            window.location.reload();
        };
    },
    onLoginBefore: function () {
        self.location.reload();
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFzc3BvcnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYXNzcG9ydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUVBLHlEQUFtQztBQUduQyxrQkFBZTtJQUNYOztRQUVJO0lBQ0osT0FBTyxFQUFFO1FBRUwsSUFBSSxTQUFTLEdBQUc7WUFDWixZQUFZLEVBQUUsS0FBSztZQUNuQixjQUFjLEVBQUUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEdBQUcsa0JBQWtCO1lBQ3pELFVBQVUsRUFBRSxTQUFTO1lBQ3JCLGFBQWEsRUFBRSxJQUFJLENBQUMsUUFBUSxDQUFDLElBQUk7WUFDakMsTUFBTSxFQUFFO2dCQUNKLFlBQVksRUFBRSx3QkFBd0I7Z0JBQ3RDLFlBQVksRUFBRSxLQUFLO2dCQUNuQixhQUFhLEVBQUUsUUFBUTtnQkFDdkIsU0FBUyxFQUFFLFFBQVE7YUFDdEI7U0FDSixDQUFDO1FBRUYsVUFBVTtRQUNWLElBQUksUUFBUSxHQUFHLGdEQUFnRCxHQUFHLGtCQUFrQixDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQztRQUNoSCxJQUFJLFNBQVMsR0FBRyx1RUFBdUUsR0FBRyxRQUFRLEdBQUcsWUFBWSxDQUFDO1FBRWxILElBQUksVUFBVSxHQUFHLElBQUksZUFBSyxDQUFDO1lBQ3ZCLE9BQU8sRUFBRSxTQUFTO1lBQ2xCLFNBQVMsRUFBRSxLQUFLO1NBQ25CLENBQUMsQ0FBQztRQUVILFVBQVUsQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUVaLE1BQU8sQ0FBQyxPQUFPLEdBQUc7WUFDcEIsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUM3QixDQUFDLENBQUM7SUFDTixDQUFDO0lBQ0QsYUFBYSxFQUFFO1FBQ1gsSUFBSSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEVBQUUsQ0FBQztJQUMzQixDQUFDO0NBQ0osQ0FBQSJ9